export default {
  "content": "<circle cx=\"10\" cy=\"10\" r=\"10\" fill=\"#EBEBF0\"/><path d=\"M11.067 4.732h.042V14H9.89V6.51l-1.946.798V6.132l3.122-1.4z\" fill=\"#3F4450\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};